/**
 * @typedef {Object} props
 * @property {number} to
 * @property {number} duration
 * @property {DOM} element
 * @property {string} direction
 * @property {number} more
 */
// to === absolute position to scroll
// duration === animation time
// element === dom element to scroll
// direction === Left || Top , direction scroll vertical or horizontal
// more === currentScrollPosition + more
export const scrolling = props => {
    const { to, duration, element, direction, more } = props;
    const from = element[`scroll${direction}`];
    const realTo = more ? from + more : to;
    const start = performance.now();
    const timeK = duration / 100;
    const percentStepValue = (from - realTo) / 100;
    const draw = s => {
        element[`scroll${direction}`] = s;
    };
    const step = () => {
        const now = performance.now();
        const timePassed = now - start;
        if (timePassed < duration) {
            draw(from - (timePassed / timeK) * percentStepValue);
            requestAnimationFrame(step);
        } else {
            draw(realTo);
        }
    };
    requestAnimationFrame(step);
};
